import React from 'react';
import ExamEligibility from '../../modules/examRegistration/components/ExamEligibility';

const RegisterExam = () => (
  <>
    <ExamEligibility />
  </>
);

export default RegisterExam;
